export const partyOrder = [
  'EAG',
  'PdA',
  'AL',
  'SOL',
  'DA',
  'SE',
  'JA',
  'JSVR',
  'SP',
  'JUSO',
  'Grüne',
  'JG',
  'GLP',
  'JGLP',
  'BDP',
  'JBDP',
  'EVP',
  'CVP',
  'JCVP',
  'CSPO',
  'JCSPO',
  'PPS',
  'LDU',
  'CSP',
  'JCSP',
  'PCSI',
  'CSPOW',
  'LPS',
  'LDP',
  'JLDP',
  'FDP',
  'JFS',
  'UP',
  'SVP',
  'JSVP',
  'MCR',
  'MCRJ',
  'Lega',
  'MCG',
  'PNOS',
  'EDU',
  'JEDU',
  'SD',
  'AUTO',
  'FPS',
  'Parteilos',
  'Andere-links',
  'Andere-rechts',
  'Andere'
]

export const partyOrderLowercase = [
  'EAG'.toLowerCase(),
  'PdA'.toLowerCase(),
  'AL'.toLowerCase(),
  'SOL'.toLowerCase(),
  'DA'.toLowerCase(),
  'SE'.toLowerCase(),
  'JA'.toLowerCase(),
  'JSVR'.toLowerCase(),
  'SP'.toLowerCase(),
  'JUSO'.toLowerCase(),
  'Grüne'.toLowerCase(),
  'JG'.toLowerCase(),
  'GLP'.toLowerCase(),
  'JGLP'.toLowerCase(),
  'BDP'.toLowerCase(),
  'JBDP'.toLowerCase(),
  'EVP'.toLowerCase(),
  'CVP'.toLowerCase(),
  'JCVP'.toLowerCase(),
  'CSPO'.toLowerCase(),
  'JCSPO'.toLowerCase(),
  'PPS'.toLowerCase(),
  'LDU'.toLowerCase(),
  'CSP'.toLowerCase(),
  'JCSP'.toLowerCase(),
  'PCSI'.toLowerCase(),
  'CSPOW'.toLowerCase(),
  'LPS'.toLowerCase(),
  'LDP'.toLowerCase(),
  'JLDP'.toLowerCase(),
  'FDP'.toLowerCase(),
  'JFS'.toLowerCase(),
  'UP'.toLowerCase(),
  'SVP'.toLowerCase(),
  'JSVP'.toLowerCase(),
  'MCR'.toLowerCase(),
  'MCRJ'.toLowerCase(),
  'Lega'.toLowerCase(),
  'MCG'.toLowerCase(),
  'PNOS'.toLowerCase(),
  'EDU'.toLowerCase(),
  'JEDU'.toLowerCase(),
  'SD'.toLowerCase(),
  'AUTO'.toLowerCase(),
  'FPS'.toLowerCase(),
  'Parteilos'.toLowerCase(),
  'Andere-links'.toLowerCase(),
  'Andere-rechts'.toLowerCase(),
  'Andere'.toLowerCase()
]
